import React from "react";
import { useAppSelector } from "../../../redux/hooks";
import SidebarLink, { SidebarLinkProps } from "./SidebarLink";

const roleClaimType =
    "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

interface Props extends SidebarLinkProps {
    permission?: string;
    userTypes?: string[];
    requiredIntegration?: string;
    displayFlag?: string;
}

const PrivateSidebarLink = ({
    permission,
    userTypes,
    requiredIntegration,
    displayFlag,
    ...other
}: Props) => {
    const { [roleClaimType]: userType, permissions } = useAppSelector(
        (state) => state.authentication.user
    );
    const { flags, pythonIntegrations } = useAppSelector(
        (state) => state.config
    );

    if (permission && !permissions.includes(permission)) return null;

    if (userTypes && userTypes.length > 0 && !userTypes.includes(userType))
        return null;

    if (!permission && !userTypes) return null;

    if (
        requiredIntegration &&
        !pythonIntegrations.includes(requiredIntegration)
    )
        return null;

    if (displayFlag && displayFlag.length > 0 && flags[displayFlag] === false)
        return null;

    return (
        <SidebarLink
            {...{
                ...other,
            }}
        />
    );
};

export default PrivateSidebarLink;
